import React from 'react';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const Footer = () => {
    return (

        <footer className="pt-5 text-center text-white" style={{ backgroundColor: '#413B65' }}>
            <div className="row d-flex align-items-center shadow-lg p-5 text-white col-11 col-lg-9 mx-auto start-project">
                <div className="col-lg-3 mx-auto">
                    <h3 className="fw-bold">Start a Project</h3>
                </div>
                <div className="col-lg-4 mx-auto">
                    <small>Interested in working together? We should queue up a chat. I’ll buy the coffee.</small>
                </div>
                <div className="col-lg-3 mx-auto mt-3 mt-lg-0">
                    <Link to="/contact">
                        <button className="btn btn-outline-light rounded-pill btn-lg">Let's do this <FontAwesomeIcon icon={faPaperPlane} /></button>
                    </Link>
                </div>
            </div>

            <div className="container p-4 pb-0">
                <section className="mb-4">

                    <a className="btn btn-outline-light btn-floating m-1"
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.facebook.com/saalim.shadman.10" role="button"
                    ><i className="fab fa-facebook-f"></i
                    ></a>


                    <a className="btn btn-outline-light btn-floating m-1"
                        target="_blank"
                        rel="noreferrer" href="https://twitter.com/shadman_saalim" role="button"
                    ><i className="fab fa-twitter"></i
                    ></a>

                    <a className="btn btn-outline-light btn-floating m-1"
                        target="_blank"
                        rel="noreferrer" href="https://www.linkedin.com/in/shadmansaalim/" role="button"
                    ><i className="fab fa-linkedin-in"></i
                    ></a>


                    <a className="btn btn-outline-light btn-floating m-1"
                        target="_blank"
                        rel="noreferrer" href="https://github.com/shadmansaalim" role="button"
                    ><i className="fab fa-github"></i
                    ></a>

                    <a className="btn btn-outline-light btn-floating m-1"
                        target="_blank"
                        rel="noreferrer" href="https://devpost.com/s3876845?ref_content=user-portfolio&ref_feature=portfolio&ref_medium=global-nav" role="button"
                    ><i class="fa-brands fa-dev"></i>
                    </a>


                </section>

            </div>

            <div className="text-center p-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
                © {new Date().getFullYear()} All Rights Reserved To Saalim Shadman
            </div>

        </footer>
    );
};

export default Footer;